import { render, staticRenderFns } from "./SpecImportPopupWrappable.vue?vue&type=template&id=49b03aab&scoped=true&lang=pug&"
import script from "./SpecImportPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./SpecImportPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./SpecImportPopupWrappable.vue?vue&type=style&index=0&id=49b03aab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b03aab",
  null
  
)

export default component.exports